/**
 * TodaySpendGauge — today's running AI spend as a KPI tile (P3). Thin wrapper
 * over KpiStatCard with i18n labels from the shared `admin` namespace.
 */
import { type ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { ADMIN_NS } from "@/features/admin/api";
import { KpiStatCard } from "@/features/admin/ai-usage/components/KpiStatCard";
import type { TodayGaugeResponse } from "@/features/admin/ai-usage/api";

export function TodaySpendGauge({ today }: { today: TodayGaugeResponse }): ReactElement {
  const { t } = useTranslation(ADMIN_NS);
  return (
    <KpiStatCard
      label={t("aiUsage.today.label")}
      value={`$${today.cost_usd.toFixed(2)}`}
      hint={t("aiUsage.today.tokens", { count: today.tokens })}
    />
  );
}
export default TodaySpendGauge;
